import { isApp } from '@/utils/client'

export default [
  {
    path: '/shopIndex',
    name: 'shopIndex',
    component: () => import('@/views/shop/Index.vue'),
    meta: { title: 'shop_mall', pageLevel: 2 }
  },
  {
    path: '/shopDetail',
    name: 'ShopDetail',
    component: () => import('@/views/shop/ShopDetail.vue'),
    meta: { title: 'product_details', pageLevel: 3 }
  },
  {
    path: '/orderPay',
    name: 'orderPay',
    component: () => import('@/views/shop/OrderPay.vue'),
    meta: { title: 'confirm_order' }
  },
  {
    path: '/pay',
    name: 'pay',
    component: () => import('@/views/shop/Pay.vue'),
    meta: { title: '支付方式' }
  },
  {
    path: '/payResult',
    name: 'payResult',
    component: () => import('@/views/shop/PayResult.vue'),
    meta: { title: '确认支付' }
  },
  {
    path: '/orderList',
    name: 'OrderList',
    component: () => import('@/views/shop/OrderList.vue'),
    meta: { title: 'order_list', isKeepAlive: true }
  },
  {
    path: '/orderDetail',
    name: 'orderDetail',
    component: () => import('@/views/shop/OrderDetail.vue'),
    meta: { title: 'order_detail' }
  },
  {
    path: '/integral',
    name: 'integral',
    component: () => import('@/views/shop/Integral.vue'),
    meta: { title: 'shop_integral' }
  },
  {
    path: '/PhysicalPayResult',
    name: 'physicalPayResult',
    component: () => import('@/views/shop/PhysicalPayResult.vue'),
    meta: { title: '确认支付' }
  },
  {
    path: '/payTransfer',
    name: 'payTransfer',
    component: () => import('@/views/shop/PayTransfer.vue'),
    meta: { title: 'cashier' } // 转账支付
  },
  {
    path: '/merchantDetail',
    name: 'MerchantDetail',
    component: () => import('@/views/shop/MerchantDetail.vue'),
    meta: { title: 'store_details', isKeepAlive: !isApp }
  }
]
